import script from "./Jewel_results_panel.vue?vue&type=script&setup=true&lang=js"
export * from "./Jewel_results_panel.vue?vue&type=script&setup=true&lang=js"

import "./Jewel_results_panel.vue?vue&type=style&index=0&id=4282c36c&scoped=true&lang=scss"

import exportComponent from "/opt/www/novasector.net/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4282c36c"]])

export default __exports__